
import Vue from 'vue'
import {TOGGLE_APP_DRAWER} from '@/store/action-types'
import UserDropDown from '@/components/user/UserDropDown.vue'
import {Component, Prop} from 'vue-property-decorator'
import { CurrentUser } from '@/model/CurrentUser'
import {GET_MODE, GET_SHOW_LOGOUT_TIMER_MODE, USER_LOGGED_IN} from '@/store/getter-types'

@Component({
  components: {
    UserDropDown
  }
})
export default class AppToolbar extends Vue {

  @Prop({type: Number, required: false}) countDown!: number

  private showMenu: boolean = false


  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get showLogOutTimer (): boolean {
    return this.$store.getters[GET_SHOW_LOGOUT_TIMER_MODE]
  }

  get getTimerClass (): string {
    return this.countDown <= 10 ? 'timer' : ''
  }

  get userLoggedIn(): CurrentUser{
    return this.$store.getters[USER_LOGGED_IN]
  }

  get getProgress(): number {
    return (100/30) * parseInt(this.countDown.toString())
  }

  toggleAppDrawer () {
    this.$store.dispatch(TOGGLE_APP_DRAWER)
  }

  closeMenu (): void {
    this.showMenu = false
  }

  mounted() {
  }
}
